<template>
  <v-row no-gutters>
    <v-col cols="12" md="6">
      <span class="subtitle-2" style="color:#2661FF">
        {{ label }}
      </span>
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <span class="body-2 font-weight-regular text_color">
        {{ value ? value : "-" }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "InfoRow",
  props: {
    label: {
      type: String,
      required: true,
      default: ""
    },
    value: {
      required: true,
      default: ""
    }
  }
};
</script>

<style>
.text_color {
  color: #344054 !important;
}
</style>
